import { useState, useEffect } from 'react';

/**
 * Custom hook to track when a form was loaded
 * Used for spam detection (forms filled too quickly are likely bots)
 * @returns {number} Unix timestamp when form loaded
 */
export const useFormLoadTime = () => {
  const [loadTime] = useState(() => Date.now() / 1000); // Unix timestamp in seconds
  
  return loadTime;
};
